import styled from 'styled-components';

import { Link } from 'react-router-dom';

interface ColourProps {
    $colour: string;
}

const styles = (colour: string) => `
    font-weight: 100;
    text-decoration: underline;
    color: ${colour};

    @media (hover: hover) {
        :hover {
            text-decoration: none;
        }
    }
`;

export const RRLinkContainer = styled(Link)<ColourProps>`
    ${({ $colour }) => styles($colour)}
`;

RRLinkContainer.displayName = 'RRLinkContainer';

export const AnchorContainer = styled.a<ColourProps>`
    ${({ $colour }) => styles($colour)}
`;

AnchorContainer.displayName = 'AnchorContainer';
